//CUSTOM CODE - Steve

//options text on hover over variant

//grabs text of class variant-title-capture and displays on "options:" if variant hovered over
if (window.mobileAndTabletcheck() == false) {
  function hoverClass() {
    let hov = document.getElementsByClassName("product-options-hover");
    let opt = document.getElementsByClassName("options-text");
    let titlecap = document.getElementsByClassName("variant-title-capture");
    var selectedTitle = opt[0].innerHTML;

    for (let i = 0; i < hov.length; i++) {
      hov[i].onmouseover = function () {
        opt[0].classList.add("hover");
        titlecap[i].classList.add("variant-hover");
        let title = document.getElementsByClassName("variant-hover");
        let hoverTitle = title[0].innerText;
        opt[0].innerHTML = hoverTitle;
      };


      hov[i].onmouseleave = function () {
        let title = document.getElementsByClassName("variant-hover");
        opt[0].classList.remove("hover");
        titlecap[i].classList.remove("variant-hover");
        hoverTitle = null;
        opt[0].innerHTML = selectedTitle;
      };
    }
  }

  // grid item counter & class add

  // every time find grid item class (product-page-variant), increase counter at end, check counter, and depending on the number, add different class to options grid items

  function gridCount() {
    let item = document.getElementsByClassName("product-page-variant");
    let count = 0;
    for (let i = 0; i < item.length; i++) {
      count++;
    }
    if (count <= 3) {
      for (let p = 0; p < item.length; p++) {
        item[p].classList.add("gridSmall");
      }
    } else if (count >= 4 && count < 7) {
      for (let p = 0; p < item.length; p++) {
        item[p].classList.add("gridMedium");
      }
    } else if (count >= 7 && count < 10) {
      for (let p = 0; p < item.length; p++) {
        item[p].classList.add("gridLarge");
      }
    } else if (count >= 10 && count < 13) {
      for (let p = 0; p < item.length; p++) {
        item[p].classList.add("gridXL");
      }
    } else if (count >= 13) {
      for (let p = 0; p < item.length; p++) {
        item[p].classList.add("gridXXL");
      }
    }
  }

  hoverClass();
  gridCount();
}

//hook web/some mobile classes to variables

var conditionbox = document.getElementsByClassName("condition-box");
var glider = document.getElementsByClassName("glider");
var gliderbox = document.getElementsByClassName("glider-overflow-box");
var glidermobile = document.getElementsByClassName("glider-mobile");
var gliderslide = document.getElementsByClassName("glider-slide");
var hover = document.getElementsByClassName("hover");
var variantcondition = document.getElementsByClassName("variant-condition");
var variantconditionweb = document.getElementsByClassName("variant-condition-web");
var varianthover = document.getElementsByClassName("variant-hover");
var optionsbox = document.getElementsByClassName("options-box");
var optionstext = document.getElementsByClassName("options-text");
var infotitleoptions = document.getElementsByClassName("product-form__info-title-options");
var infocontentglider = document.getElementsByClassName("product-form__info-content-glider");
var infotitleoptions = document.getElementsByClassName("product-form__info-title-options");
var variantselectedmobile = document.getElementsByClassName("product-page-variant-selected-mobile");
var productpagevariantgrid = document.getElementsByClassName(
  "product-page-variant-grid"
);
var productoptionsgrid = document.getElementsByClassName(
  "product-options-grid"
);
var productpagevariant = document.getElementsByClassName(
  "product-page-variant"
);
var productpagevarianthover = document.getElementsByClassName(
  "product-page-variant:hover"
);
var productpagevarianttitle = document.getElementsByClassName(
  "product-page-variant-title"
);
var productpagevarianttitlemobile = document.getElementsByClassName(
  "product-page-variant-title-mobile"
);
var productpagevariantselected = document.getElementsByClassName(
  "product-page-variant-selected"
);
var productpagevariantprice = document.getElementsByClassName(
  "product-page-variant--price"
);
var productpagevariantimg = document.getElementsByClassName(
  "product-page-variant-img"
);
var pricevariant = document.getElementsByClassName("price-variant");
var pricehighlightvariant = document.getElementsByClassName(
  "price--highlight-variant"
);
var pricecomparevariant = document.getElementsByClassName(
  "price--compare-variant"
);
var pricecompare = document.getElementsByClassName("price--compare");
var productitemimgopenbox = document.getElementsByClassName(
  "product-item-img-openbox"
);
var productitemimgrefurb = document.getElementsByClassName(
  "product-item-img-refurb"
);
var productpagevariant = document.getElementsByClassName(
  "product-page-variant"
);
var pricevariantsoldout = document.getElementsByClassName(
  "price-variant-soldout"
);

var pricevariantsoldout = document.getElementsByClassName(
  "price-variant-soldout"
);

var variantconditionmobile = document.getElementsByClassName(
  "variant-condition-mobile"
);
var productpagevariantmobile = document.getElementsByClassName(
  "product-page-variant-mobile"
);


//add mobile classes if mobile, set properties to some mobile classes

if (window.mobileAndTabletcheck() && (document.documentElement.clientWidth * window.devicePixelRatio) < (992 * window.devicePixelRatio)) {

  for (var i = 0; i < optionsbox.length; i++) {
    optionsbox[i].classList.add("options-box-mobile");
  }

  for (var i = 0; i < glider.length; i++) {
    glider[i].classList.add("glider-mobile");
  }

    for (var i = 0; i < gliderbox.length; i++) {
    gliderbox[i].classList.add("glider-overflow-box-mobile");
  }

  for (var i = 0; i < infotitleoptions.length; i++) {
    infotitleoptions[i].classList.add("product-form__info-title-options-mobile");
  }

  for (var i = 0; i < optionstext.length; i++) {
    optionstext[i].classList.add("options-text-mobile");
  }

  for (var i = 0; i < productpagevariantgrid.length; i++) {
    productpagevariantgrid[i].classList.add("product-page-variant-grid-mobile");
  }

  for (var i = 0; i < productoptionsgrid.length; i++) {
    productoptionsgrid[i].classList.add("product-options-grid-mobile");
  }

  for (var i = 0; i < productpagevariant.length; i++) {
    productpagevariant[i].classList.add("product-page-variant-mobile");
  }

  for (var i = 0; i < productpagevarianttitle.length; i++) {
    productpagevarianttitle[i].classList.add(
      "product-page-variant-title-mobile"
    );
  }

  for (var i = 0; i < productpagevariantselected.length; i++) {
    productpagevariantselected[i].classList.add(
      "product-page-variant-selected-mobile"
    );
  }
  for (var i = 0; i < productpagevariantprice.length; i++) {
    productpagevariantprice[i].classList.add(
      "product-page-variant--price-mobile"
    );
  }
  for (var i = 0; i < productpagevariantimg.length; i++) {
    productpagevariantimg[i].classList.add("product-page-variant-img-mobile");
  }
  for (var i = 0; i < pricevariant.length; i++) {
    pricevariant[i].classList.add("price-variant-mobile");
  }
  for (var i = 0; i < variantcondition.length; i++) {
    variantcondition[i].classList.add("variant-condition-mobile");
  }
  for (var i = 0; i < variantconditionweb.length; i++) {
    variantconditionweb[i].style.display = "none";
  }
  for (var i = 0; i < productpagevariant.length; i++) {
    productpagevariant[i].classList.add("product-page-variant-mobile");
  }
  for (var i = 0; i < infocontentglider.length; i++) {
    infocontentglider[i].classList.add("product-form__info-content-glider-mobile");
  }
  

  //only add if these classes exist (product variant-dependent)

  if (hover.length > 0) {
    for (var i = 0; i < hover.length; i++) {
      hover[i].classList.add("hover-mobile");
    }
  }

  if (varianthover.length > 0) {
    for (var i = 0; i < varianthover.length; i++) {
      varianthover[i].classList.add("variant-hover-mobile");
    }
  }

  if (productpagevarianthover.length > 0) {
    for (var i = 0; i < productpagevarianthover.length; i++) {
      productpagevarianthover[i].classList.add(
        "product-page-variant-mobile:hover"
      );
    }
  }

  if (pricehighlightvariant.length > 0) {
    for (var i = 0; i < pricehighlightvariant.length; i++) {
      pricehighlightvariant[i].classList.add("price--highlight-variant-mobile");
    }
  }

  if (pricecomparevariant.length > 0) {
    for (var i = 0; i < pricecomparevariant.length; i++) {
      pricecomparevariant[i].classList.add("price--compare-variant-mobile");
    }
  }

  if (productitemimgopenbox.length > 0) {
    for (var i = 0; i < productitemimgopenbox.length; i++) {
      productitemimgopenbox[i].classList.add("product-item-img-openbox-mobile");
    }
  }

  if (productitemimgrefurb.length > 0) {
    for (var i = 0; i < productitemimgrefurb.length; i++) {
      productitemimgrefurb[i].classList.add("product-item-img-refurb-mobile");
    }
  }

  if (pricevariantsoldout.length > 0) {
    for (var i = 0; i < pricevariantsoldout.length; i++) {
      pricevariantsoldout[i].classList.add("price-variant-soldout-mobile");
    }
  }

  //hide/display condition-box[-mobile] if mobile

  var conditionboxmobile = document.getElementsByClassName(
    "condition-box-mobile"
  );

  for (var i = 0; i < conditionboxmobile.length; i++) {
    conditionboxmobile[i].style.display = "block";
  }

  for (var i = 0; i < conditionbox.length; i++) {
    conditionbox[i].style.display = "none";
  }

  //grey all variant text if product sold out

  for (var p = 0; p < productpagevariantprice.length; p++) {
    if (pricevariantsoldout.length > 0) {
      for (var i = 0; i < pricevariantsoldout.length; i++) {
        if (
          document
            .getElementsByClassName("product-page-variant--price")
            [p].getElementsByClassName("price-variant-soldout")[i] != null
        ) {
          productpagevarianttitlemobile[p].style.color = "#677279";
          variantcondition[p].style.color = "#677279";
        }
      }
    }
  }
}
  //change "Options" text to "Current Option" on mobile

        // infotitleoptions[0].innerHTML = "Current Option:";


  // variantselectedmobile.scrollIntoView();

  // glidermobile.scrollLeft = 500;


